import React, { useEffect, useState } from "react";
import Style from "./GiftCardsDesign.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Scrollbar, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/scrollbar";
import { useGiftCard } from "../../../logic/useGiftCard";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

const GiftCardsDesign = ({ formik, basicData }) => {
  const [filteredCards, setFilteredCards] = useState([]);

  const { t } = useTranslation(["common"]);
  const { giftCardData } = useGiftCard();

  useEffect(() => {
    const switcher = document.getElementsByClassName("switcher")[0];
    if (
      switcher.attributes?.dir?.value === "rtl" &&
      giftCardData.length !== 0
    ) {
      const filteredArr = giftCardData.filter((value) => value.card_type === 2);

      setFilteredCards(filteredArr);
    } else if (
      switcher.attributes?.dir?.value === undefined ||
      switcher.attributes?.dir?.value === "ltr"
    ) {
      const filteredArr = giftCardData.filter((value) => value.card_type === 1);
      setFilteredCards(filteredArr);
    }
  }, [giftCardData]);

  const handleError = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return <div className={Style.cardError}>{formik.errors.giftCard}</div>;
  };

  const { lang: langSlug } = useParams();

  return (
    <section className={Style.gift_cards}>
      <div className="giftCard_container">
        {basicData?.status == 1 && (
          <h1 className={`${Style.gift_cards_title} mb-0`}>
            {/* {langSlug === "en"
              ? ` Buy a gift card worth omr ${parseInt(
                  basicData?.minimum_amount
                )} and above and get and addittional ${parseInt(
                  basicData?.percentage
                )}% bonus added to you card`
              : ` قم بشراء بطاقة هدايا بقيمة ${parseInt(
                  basicData?.minimum_amount
                )} درهم أو أكثر واحصل على مكافأة إضافية بقيمة ${parseInt(
                  basicData?.percentage
                )}% تضاف إلى بطاقتك `} */}
            {basicData?.message}
          </h1>
        )}
        <Swiper
          scrollbar={{
            el: ".swiper-scrollbar",
            draggable: true,
            dragSize: 98,
          }}
          navigation={true}
          dir={langSlug == "ar" ? "rtl" : "ltr"}
          allowTouchMove={true}
          spaceBetween={25}
          slidesPerView={1.5}
          modules={[Scrollbar, Navigation]}
          className={Style.gift_cards_swiper}
          breakpoints={{
            320: {
              slidesPerView: 1.4,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 22,
            },
            992: {
              slidesPerView: 4,
              spaceBetween: 25,
            },
            1200: {
              slidesPerView: 4,
              spaceBetween: 18,
              allowTouchMove: false,
            },
          }}
        >
          {giftCardData &&
            giftCardData.length > 0 &&
            filteredCards.map((value, i) => {
              return (
                <SwiperSlide key={value.id}>
                  <div className={Style.gift_card_box} key={value.id}>
                    <input
                      type="radio"
                      name="giftCard"
                      id={value.id}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.id || value.id}
                      checked={
                        formik.values.giftCard == value.id ? true : false
                      }
                    />
                    <label htmlFor={value.id}>
                      <figure>
                        <img src={value.gift_card_full_url} alt="Gift Card" />
                      </figure>
                      <div className={Style.content_section}>
                        <p className={`${Style.card_name} mb-0`}>
                          {value.title}
                        </p>
                        <p className={`${Style.card_desc} mb-0`}>
                          {value.description}
                        </p>
                        <p className={`${Style.select_btn} mb-0`}>
                          {t("Select")}
                        </p>
                      </div>
                    </label>
                  </div>
                </SwiperSlide>
              );
            })}

          <div
            className={`swiper-scrollbar ${Style.gift_cards_swiper_scrollbar}`}
          ></div>
          {formik.touched.giftCard && formik.errors.giftCard
            ? handleError()
            : null}
        </Swiper>
      </div>
    </section>
  );
};

export default GiftCardsDesign;
